import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSearch, faInfoCircle, faSitemap, faPencilRuler, faUser,
  faHeartbeat, faClock, faAngleUp, faAngleDown,
  faAngleRight, faAngleLeft, faDoorOpen,
} from '@fortawesome/free-solid-svg-icons';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Login from 'login/Login';
import Loading from 'layout/Loading';
import axios from 'axios';
import Background from 'images/bg_blur.jpg';
import { UserProvider } from 'login/withUser';
import { LOGOUT_URL, USER_URL, defaultAdvancedSearchFilter } from './config';
import MainLayout, { MainLayoutWithElephant } from './layout/MainLayout';
import ErrorMessage, { UserInfoError } from './layout/ErrorMessage';

library.add([faSearch, faInfoCircle, faSitemap, faPencilRuler,
  faHeartbeat, faUser, faClock, faAngleUp, faAngleDown,
  faAngleRight, faAngleLeft, faDoorOpen]);


const theme = createMuiTheme({
  palette: {
    primary: { main: '#ae1704' },
    secondary: { main: '#efefef' },
  },
  lifeline: {
    palette: (window.COLORS && window.COLORS.LIFELINE_COLORS)
      ? window.COLORS.LIFELINE_COLORS
      : {
        wild: 'orange',
        captive: '#b16421',
        logbook: '#005f00',
        markers: {
          measure: '#478dff',
          logbook: '#70b270',
          time: '#ae1704',
        },
      },
  },
  logbook: {
    palette: (window.COLORS && window.COLORS.LOGBOOK_COLORS)
      ? window.COLORS.LOGBOOK_COLORS
      : {
        logbookEntry: '#fff1d8',
        eventEntry: '#ffc356',
        timeMarker: '#ae1704',
      },
  },
  typography: {
    fontFamily: ['Encode Sans Condensed'],
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 840,
      lg: 1280,
      xl: 1920,
    },
  },
});


export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.logout = this.logout.bind(this);

    this.state = {
      loadingUser: true,
      apiConnectionError: null,
      user: null,
      advancedSearchFilters: [
        {
          ...defaultAdvancedSearchFilter, index: 0,
        },
      ],
      searchParameter: '',
      searchResult: {
        results: [],
        previous: null,
        next: null,
        count: 0,
      },
      currentPage: 0,
      usingAdvancedSearch: false,
    };

    this.setSearchResult = this.setSearchResult.bind(this);
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.setUsingAdvancedSearch = this.setUsingAdvancedSearch.bind(this);
    this.setAdvancedSearchFilters = this.setAdvancedSearchFilters.bind(this);
    this.setSearchParameter = this.setSearchParameter.bind(this);
  }

  async componentDidMount() {
    try {
      const user = await this.fetchUser();
      this.setState({ user, loadingUser: false });
    } catch (err) {
      this.setState({ apiConnectionError: err, loadingUser: false });
    }
  }

  setSearchResult(searchResult) {
    this.setState({ searchResult });
  }

  setCurrentPage(currentPage) {
    this.setState({ currentPage });
  }

  setUsingAdvancedSearch(madeAdvancedSearch) {
    this.setState({ usingAdvancedSearch: madeAdvancedSearch });
  }

  setAdvancedSearchFilters(advancedSearchFilters) {
    this.setState({ advancedSearchFilters });
  }

  setSearchParameter(searchParameter) {
    this.setState({ searchParameter });
  }

  async fetchUser() {
    try {
      return (await axios.get(USER_URL)).data;
    } catch (err) {
      if (err && err.response && err.response.status === 403) {
        return null;
      }
      throw new UserInfoError('Error connecting to the API');
    }
  }

  async logout() {
    try {
      await axios.post(LOGOUT_URL);
    } catch (err) {
      // After logout, the server should return 403 or 404 if user is successfully logged out
      if (err.response.status === 403 || err.response.status === 404) {
        this.setState({ user: null });
      }
    }
  }

  render() {
    const {
      user, loadingUser, apiConnectionError, advancedSearchFilters,
      searchParameter, searchResult, currentPage, usingAdvancedSearch,
    } = this.state;
    return (
      <div
        style={{
          height: '100%',
          fontFamily: 'Encode Sans Condensed !important',
          background: `url(${Background})`,
          backgroundSize: 'cover',
          overflow: 'hidden',
        }}
      >
        <MuiThemeProvider
          theme={theme}
        >
          {
            apiConnectionError
              ? <ErrorMessage error={apiConnectionError} />
              : loadingUser
                ? <Loading />
                : user !== null
                  ? (
                    <UserProvider value={{
                      logout: this.logout,
                      user,
                    }}
                    >
                      <Router>
                        <Switch>
                          <Route
                            path="/elephant/:id/"
                            render={props => (
                              <MainLayoutWithElephant
                                advancedSearchFilters={advancedSearchFilters}
                                setAdvancedSearchFilters={this.setAdvancedSearchFilters}
                                searchResult={searchResult}
                                setSearchResult={this.setSearchResult}
                                currentPage={currentPage}
                                setCurrentPage={this.setCurrentPage}
                                usingAdvancedSearch={usingAdvancedSearch}
                                setUsingAdvancedSearch={this.setUsingAdvancedSearch}
                                searchParameter={searchParameter}
                                setSearchParameter={this.setSearchParameter}
                                {...props}
                              />
                            )}
                          />
                          <Route
                            render={() => (
                              <MainLayout
                                advancedSearchFilters={advancedSearchFilters}
                                setAdvancedSearchFilters={this.setAdvancedSearchFilters}
                                searchResult={searchResult}
                                setSearchResult={this.setSearchResult}
                                currentPage={currentPage}
                                setCurrentPage={this.setCurrentPage}
                                usingAdvancedSearch={usingAdvancedSearch}
                                setUsingAdvancedSearch={this.setUsingAdvancedSearch}
                                searchParameter={searchParameter}
                                setSearchParameter={this.setSearchParameter}
                              />
                            )}
                          />
                        </Switch>
                      </Router>
                    </UserProvider>
                  )
                  : <Login /> }
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.jsx